import { LocationParamsType } from 'tennders-common/types/LocationParams'
import useCountries from 'tennders-common/hooks/useCountries'
import usePopup from 'tennders-common/hooks/usePopup'
import useTranslation from 'next-translate/useTranslation'
import useInitials from 'tennders-common/hooks/useInitials'

const useGooglePlaceDetails = ({ placesService, onSet, setSuggestions }) => {
  const { t } = useTranslation()
  const { boxOwner } = useInitials()
  const { supportedCounties } = useCountries()
  const { popWarning } = usePopup()

  const getDetails = ({ item }) => {
    placesService?.getDetails(
      { placeId: item.place_id },
      (place) => {
        const addr = [...place.address_components]
        const locationParams : LocationParamsType = {
          id: place.place_id,
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng(),
          label: place.formatted_address
        }
        while (addr.length > 0) {
          const addrItem = addr.pop()
          if (addrItem.types.indexOf('country') > -1) {
            locationParams.country = addrItem.short_name
          } else if (addrItem.types.indexOf('state') > -1) {
            locationParams.state = addrItem.long_name
          } else if (addrItem.types.indexOf('locality') > -1) {
            locationParams.city = addrItem.long_name
          } else if (addrItem.types.indexOf('postal_code') > -1) {
            locationParams.postalCode = addrItem.long_name
          }
        }
        if (!locationParams.country) {
          popWarning({ msg: t('prompt:no_country_detected') })
          return
        }

        if (onSet) {
          onSet(locationParams)
        }
        setSuggestions([])
      }
    )
  }
  return { getDetails }
}

export default useGooglePlaceDetails
